/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DigitalInputs */

const en_digital = /** @type {(inputs: DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital`)
};

const es_digital = /** @type {(inputs: DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital`)
};

const fr_digital = /** @type {(inputs: DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numérique`)
};

const de_digital = /** @type {(inputs: DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital`)
};

const ja_digital = /** @type {(inputs: DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デジタル`)
};

const zh_digital = /** @type {(inputs: DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字版`)
};

const ar_digital = /** @type {(inputs: DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رقمي`)
};

const id_digital = /** @type {(inputs: DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital`)
};

const it_digital = /** @type {(inputs: DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digitale`)
};

const ru_digital = /** @type {(inputs: DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цифровая Версия`)
};

const pt_digital = /** @type {(inputs: DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital`)
};

const ko_digital = /** @type {(inputs: DigitalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디지털`)
};

/**
* | output |
* | --- |
* | "Digital" |
*
* @param {DigitalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const digital = /** @type {((inputs?: DigitalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DigitalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_digital(inputs)
	if (locale === "es") return es_digital(inputs)
	if (locale === "fr") return fr_digital(inputs)
	if (locale === "de") return de_digital(inputs)
	if (locale === "ja") return ja_digital(inputs)
	if (locale === "zh") return zh_digital(inputs)
	if (locale === "ar") return ar_digital(inputs)
	if (locale === "id") return id_digital(inputs)
	if (locale === "it") return it_digital(inputs)
	if (locale === "ru") return ru_digital(inputs)
	if (locale === "pt") return pt_digital(inputs)
	return ko_digital(inputs)
});